module.exports = __webpack_public_path__ + "static/media/wp-ai-success-br.0ac24eb8.webp";